import styled from '@emotion/styled'
import {Box} from '@mui/material'

export const LoadingBox = styled(Box)(() => ({
  flexDirection: 'column',
  marginTop: '300px',
  paddingLeft: '50%'
}))
